<template>
  <div id="header">
    <div class="about-header gotham-bold" :style="backgroundPath">
      <!-- absolute logo -->
      <div class="logo-title-wrapper container">
        <div class="content-logo-wrapper">
          <div class="logo-wrapper">
            <div class="logo-ellipse">
              <img :src="institutionProfile.logo ? institutionProfile.logo : defaultLogo" alt="logo-lembaga" id="logo-lembaga">
            </div>
          </div>
          <div class="title-wrapper">
            <p class="title-value gotham-bold">{{institutionProfile.name}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Image from '@/assets/images/lembaga/index'
export default {
  name: 'HeaderLembaga',
  data: () => ({
    defaultLogo: Image.default_logo
  }),
  props: {
    imageBackground: String,
    institutionProfile: Object
  },
  computed: {
    backgroundPath () {
      return { 'background-image': `url(${this.imageBackground})` }
    }
  }
}
</script>

<style scoped>
p{
  margin-bottom: 0px;
}
/* logo and title style */

.logo-title-wrapper{
  font-size: 14px;
}

.content-logo-wrapper{
  display: flex;
  align-items: flex-end;
}

.logo-wrapper{
  width: 150px;
  position: relative;
}

.logo-ellipse{
  position: absolute;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  background-color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  top: -100px;
}

#logo-lembaga{
  width: 70%;
}

.title-wrapper{
  padding: 0px 20px;
}

.title-value{
  font-style: normal;
  font-size: 36px;
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  color: #FFFFFF;
}

#header {
  width: 100%;
}

.about-header {
  background-size: cover;
  height: 251px;
  width: 100%;
  display: flex;
  flex-direction: row;
  /* align-items: center;
  justify-content: center; */
  align-items: flex-end;
}

.title-header {
  color: #ffffff;
  font-size: 36px;
  line-height: 45px;
}

@media screen and (max-width: 425px){
  .logo-title-wrapper{
    display: none;
  }
}

@media screen and (max-width: 375px) {
    .about-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
}

@media (max-width: 320px) {
  .description {
    background-color: #ffffff;
    width: 100%;
    height: 391px;
    display: flex;
    flex-direction: row;
  }

  .left-desc {
    width: 50%;
    display: flex;
    align-items: center;
    padding-right: 20px;
    justify-content: flex-end;
  }

  .desc {
    width: 481px;
    height: 154px;
    font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    color: rgba(0, 0, 0, 0.7);
  }

  .right-desc {
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-left: 20px;
  }
}
</style>
